import { render, staticRenderFns } from "./ArticleMostPopular.vue?vue&type=template&id=1735edda"
import script from "./ArticleMostPopular.vue?vue&type=script&lang=js"
export * from "./ArticleMostPopular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports